import React from 'react'
import UserDashboard from "../../Components/DashbaordSidebar"
import SidebarAdmin from '../../Dashboard/Sidebar/SidebarAdmin'

import { Route,Routes } from 'react-router-dom';
import Header from '../../Components/TopNavbar/Header';


export const Dashboard = () => {
  return (
<> 





  <Routes>
  <Route path="/user-dashboard/*" element={<Header />} />
  </Routes>
  <Routes>
  <Route path="/user-dashboard/*" element={<UserDashboard />} />
  </Routes>

    <Routes>
    <Route path='/admin-dashboard/*' element={<SidebarAdmin />} /> 
    </Routes>


</>
  )
}
